export const initAnimations = (): void => {
    const animatedElements = document.querySelectorAll<HTMLElement>('.fade-in-on-scroll');

    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Optional: stop observing once animated
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px -10% 0px', // Trigger slightly before the element fully enters the viewport
        threshold: 0.1
    });

    animatedElements.forEach(el => observer.observe(el));
};
